// extracted by mini-css-extract-plugin
export default {"listPart":"ToDoCircleListPart_listPart__tjFFW","items-rotate":"ToDoCircleListPart_items-rotate__0exnM"};